const documentCardStorageKeys = [
  "versionCardEquipments",
  "versionCardFile",
  "historyAddDraft",
  "approversCardDocumentData",
  "draftData",
  "objUploadFile",
  "returnToWork",
  "agreementDoc",
  "draftDoc",
  "archiveDoc",
  "changeVersion",
  "archiveEnd",
  "draftComment",
  "approversDependencies",
  "noAddArchive",
  "removeDocument",
];

export const clearDocumentCardStorage = () => {
  documentCardStorageKeys.forEach((key) => localStorage.removeItem(key));
};
